export const RESTAURANTS_START_PARAMETER = 'restaurants';
export const restaurantEntryCopy = {
  ru: { title: 'Рестораны', subtitle: 'Меню и акции', button: '🍽 Рестораны · меню и акции' },
  ro: { title: 'Restaurante', subtitle: 'Meniuri și oferte', button: '🍽 Restaurante · meniuri și oferte' },
  uk: { title: 'Ресторани', subtitle: 'Меню та акції', button: '🍽 Ресторани · меню та акції' },
} as const;
